import React from 'react'
import './inlineLoader.css'

export const InlineLoader = ({ size, ml = 0, mr = 0 }) => {
  if (!size) size = '40'
  return (
    <div className="lds-dual-ring" style={{ width: `${size}px`, height: `${size}px`, marginLeft: `${ml}rem`, marginRight: `${mr}rem` }}/>
  )
}